<template>
  <div>

    <div class="row mt-1 ml-0">
      <span>
        <l-checkbox class="mt-0" v-model="showSubmittedOnly">Submitted only</l-checkbox>
        <br>
      </span>
    </div>

    <div class="row mt-1 ml-0">
      <a class="btn-link smaller" href="#"
            @click="addPayout">
        <i class="fa fa-plus"></i> Add Payout
      </a>
    </div>

    <el-table @cell-mouse-enter="rowHover" @cell-mouse-leave="rowHoverLeave"
              @row-click="rowClick"
              id="payoutsTable" class="table-striped" 
              :data="payouts" :row-class-name="rowClasses">

      <el-table-column label="Date created" width="140">
        <template slot-scope="{row}">
          {{ displayDate(row.dateCreated) }}
        </template>
      </el-table-column>

      <el-table-column prop="id" label="ID" width="100">
        <template slot-scope="{row}">
        {{ row.incentifyerAccountId+'-'+row.id }}
        </template>
      </el-table-column>

      <el-table-column v-if="!hideCompany" label="Company" width="140">
        <template slot-scope="{row}">
          {{ getAffiliateCompanyName(row.affiliateAccountId) }}
        </template>
      </el-table-column>

      <el-table-column label="Affiliate">
        <template slot-scope="{row}">
          {{ getAffiliateName(row.affiliateAccountId) }}
        </template>
      </el-table-column>

      <el-table-column label="Incentifyer">
        <template slot-scope="{row}">
          {{ getIncentifyerName(row.incentifyerAccountId) }}
        </template>
      </el-table-column>

      <el-table-column prop="amount" label="Amount" width="80"/>

      <el-table-column prop="status" label="Status" width="80"/>

      <el-table-column prop="type" label="Reason" width="120">
        <template slot-scope="{row}">
          {{ getTypeLabel(row.type) }}
        </template>
      </el-table-column>

      <el-table-column label="Details">
        <template slot-scope="{row}">
          {{ getPayoutDetails(row) }}
        </template>
      </el-table-column>
      
      <el-table-column width="70" label="">
        <template slot-scope="{row}">
          <template v-if="row && !['pending', 'submissionRequested', 'paid'].includes(row.status)">
            <a class="btn-info text-primary btn-link d-none showOnHover mr-3" v-tooltip.top-center="`Pay all affiliate's payouts from this incentifyer`"
              @click="payAffiliatePayoutsFromIncentifyer(row.affiliateAccountId, row.incentifyerAccountId)">
              <!-- <i class="fad fa-envelope-open-dollar"></i> -->
              <i class="fad fa-dollar-sign"></i>
            </a>
            <a class="btn-info text-primary btn-link d-none showOnHover mr-1" v-tooltip.top-center="'Mark as paid'"
              @click="markAsPaid(row)">
              <i class="fad fa-sack-dollar"></i>
            </a>
          </template>
        </template>
      </el-table-column>

      <el-table-column width="1">
        <template slot-scope="{row}">
          <div :payoutid="row.incentifyerAccountId+'-'+row.id"/>
        </template>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
import { Payout } from '../../classes/datamodel'
import utils from '../../utils'
export default {
    name: 'Payouts-Table',
    props: {
      // hidePosition:       {type: Boolean, default: false},
      hideCompany:        {type: Boolean, default: false},
      // hideLeadsReceived:  {type: Boolean, default: false},
      // hideLeadsClosed:    {type: Boolean, default: false},
      // hideLeads:          {type: Boolean, default: false},
      // hidePayouts:        {type: Boolean, default: false},
      // hideCloseRate:      {type: Boolean, default: false},
      // forCompany:         {type: Object, default: null}
    },
    mounted () {
      this.$store.dispatch('fetchDataset')
      this.$store.dispatch('fetchBaseData')
    },
    data() {
      return {
        showSubmittedOnly: false
      }
    },
    computed: {
      payouts () {
        let payouts = this.$store.getters.payouts || []
        if (this.showSubmittedOnly) payouts = payouts.filter(p => p.status == 'submitted')
        return payouts
      }
    },
    methods: {
      displayDate (date) {
        return utils.dateToString(date)
        // return '-'
      },
      addPayout () {
        alert('Not yet implemented')
      },
      async payAffiliatePayoutsFromIncentifyer (affiliateAccountId, incentifyerAccountId) {
        const obj = this.modalObject
        const res = await this.$store.dispatch('payAffiliatePayoutsFromIncentifyer', { affiliateAccountId, incentifyerAccountId})

        if (res) {
          if (res.errors) {
            console.log('res.errors = ', res.errors)
            if (!res.errors[0] || typeof res.errors[0] != 'string' || !res.errors[0].toLowerCase().includes('session')) {
              this.$notify({ errorMessage: res.errors[0] })
            }
          }
          else {
            this.$notify({ successMessage: 'Payout paid & affiliate notified!'})
            this.$store.dispatch('fetchDataset')
            this.$store.dispatch('fetchBaseData')
          }
        }
        else {
          this.$notify({ errorMessage: 'Something went wrong...'})
        }
      },

      async markAsPaid (payout) {
        const res = await this.$store.dispatch(`updatePayoutStatus`, { incentifyerAccountId: payout.incentifyerAccountId,
                                                                      payoutId: payout.id,
                                                                      status: Payout._status.PAID.value
                                                                     })
        console.log('!!!!! res = ', res)
        if (res) {
          if (res.errors) {
            if (!res.errors[0].toLowerCase().includes('session')) {
              this.$notify({ errorMessage: res.errors[0] })
            }
          }
          else {
            this.$notify({ successMessage: 'Updated!' })
            payout.status = 'paid'
          }
        }
        else {
          this.$notify({ errorMessage: 'Something went wrong...'})
        }
      },
      getAffiliateCompanyName (affiliateAccountId) {
        const company = this.$store.getters.affiliateCompanies.find(c => c.id == affiliateAccountId)
        if (company && company.profile)
          return company.profile.companyName || '-'
        else
          return '-'
      },
      getAffiliate(id) {
        return this.$store.getters.users.find(a => a.id == id
                                         && a.type == 'affiliate') || {}
      },
      getAffiliateName (affiliateAccountId) {
        const affiliate = this.getAffiliate(affiliateAccountId)
        if (affiliate)
          return affiliate.firstName + ' ' + affiliate.lastName
        else
          return '-'
      },
      getPayoutDetails (payout) {
        if (payout.type == 'manual')
          return payout.note || '-'
        else {
          const lead = this.$store.getters.leads.find(l => l.id == payout.leadId
                                && l.incentifyerAccountId == payout.incentifyerAccountId)
          if (lead)
            return lead.name
          else
            return '-'
        }
      },
      getIncentifyerName (incentifyerAccountId) {
        const incentifyer = this.$store.getters.incentifyerAccounts.find(a => a.id == incentifyerAccountId)
        return incentifyer && incentifyer.profile ? incentifyer.profile.companyName || '-' : '-'
      },
      getTypeLabel (typeValue) {
      const typeObj = Object.entries(this.$store.getters.Payout._type).find(e => e[1].value == typeValue)[1]
      return typeObj ? typeObj.label : typeValue
      },

      rowClasses ({row, rowIndex}) {
        // return row.archived?'archivedTableRow clickableRow':'clickableRow'
        return row.archived?'archivedTableRow':''
      },
      rowHover(row, column, cell, event) {
        // We show all buttons of class .showOnHover
        var rows = $('#payoutsTable > div > table > tbody > tr')
        for (var i = 0; i < rows.length; i++) {
          var foundRow = JSON.stringify($(rows[i]).html().indexOf('payoutid="'+row.incentifyerAccountId+'-'+row.id+'"')) > -1
          var archivedRow = $(rows[i]).attr('class').indexOf('archivedTableRow') > -1
          if (foundRow && !archivedRow) {
            var icons = $(rows[i]).find('.showOnHover')
            for (var j = 0; j < icons.length; j++) {
              $(icons[j]).removeClass('d-none')
            }
            break
          }
        }
      },
      rowHoverLeave (row, column, cell, event) {
        // We hide all buttons of class .showOnHover
        var rows = $('#payoutsTable > div > table > tbody > tr')
        for (var i = 0; i < rows.length; i++) {
          var index = JSON.stringify($(rows[i]).html().indexOf('payoutid="'+row.incentifyerAccountId+'-'+row.id+'"'))
          if (index > -1) {
            var icons = $(rows[i]).find('.showOnHover')
            for (var j = 0; j < icons.length; j++) {
              $(icons[j]).addClass('d-none')
            }
            break
          }
        }
      },
      rowClick (row, column, event) {
        // We check to see if the click happened on an icon button
        // var match = JSON.stringify(event.toElement.classList.value).match(/fa[rsdl]{0,1}\sfa-/i)
        var path = event.path || event.composedPath() // 2nd one if for Firefox
        var match = JSON.stringify(path[0].className).match(/fa[rsdl]{0,1}\sfa-/i)
        if (match && match.index > -1) {
          // icon button, we ignore row click
        } else {
          //console.log('row click')
          //this.editPayout(row)
        }
      }
    }
}
</script>

<style>
.el-table__row .cell {
  padding: 0;
}
.has-gutter .is-leaf .cell {
  padding: 0;
}
</style>